var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlacklistRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#FCDFDF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6673_58163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 10C25.523 10 30 14.477 30 20V23.764C30 24.1355 29.8965 24.4996 29.7012 24.8156C29.5058 25.1316 29.2263 25.3869 28.894 25.553L26 27V28C26 28.7652 25.7077 29.5015 25.1827 30.0583C24.6578 30.615 23.9399 30.9501 23.176 30.995L22.95 31C22.972 30.8911 22.9867 30.7809 22.994 30.67L23 30.5V30C23.0002 29.4954 22.8096 29.0094 22.4665 28.6395C22.1234 28.2695 21.6532 28.0428 21.15 28.005L21 28H19C18.4954 27.9998 18.0094 28.1904 17.6395 28.5335C17.2695 28.8766 17.0428 29.3468 17.005 29.85L17 30V30.5C17 30.671 17.017 30.839 17.05 31H17C16.2044 31 15.4413 30.6839 14.8787 30.1213C14.3161 29.5587 14 28.7956 14 28V27L11.106 25.553C10.7735 25.3869 10.4939 25.1314 10.2986 24.8152C10.1032 24.499 9.99983 24.1347 10 23.763V20C10 14.477 14.477 10 20 10ZM20 12C17.9216 12 15.9247 12.8089 14.4323 14.2555C12.9398 15.702 12.069 17.6726 12.004 19.75L12 20V23.764L16 25.764V27.355L16.075 27.271C16.7833 26.5107 17.7602 26.0565 18.798 26.005L19 26L21.073 26.001L21.296 26.011C22.295 26.085 23.186 26.521 23.846 27.188L24 27.355V25.764L28 23.764V20C28 17.8783 27.1571 15.8434 25.6569 14.3431C24.1566 12.8429 22.1217 12 20 12ZM16 19C16.5304 19 17.0391 19.2107 17.4142 19.5858C17.7893 19.9609 18 20.4696 18 21C18 21.5304 17.7893 22.0391 17.4142 22.4142C17.0391 22.7893 16.5304 23 16 23C15.4696 23 14.9609 22.7893 14.5858 22.4142C14.2107 22.0391 14 21.5304 14 21C14 20.4696 14.2107 19.9609 14.5858 19.5858C14.9609 19.2107 15.4696 19 16 19ZM24 19C24.5304 19 25.0391 19.2107 25.4142 19.5858C25.7893 19.9609 26 20.4696 26 21C26 21.5304 25.7893 22.0391 25.4142 22.4142C25.0391 22.7893 24.5304 23 24 23C23.4696 23 22.9609 22.7893 22.5858 22.4142C22.2107 22.0391 22 21.5304 22 21C22 20.4696 22.2107 19.9609 22.5858 19.5858C22.9609 19.2107 23.4696 19 24 19Z",
    fill: "#F15D5F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6673_58163"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlacklistRed);
export default __webpack_public_path__ + "static/media/blacklist-red.353a6c3f21e5123223e8deab779fca36.svg";
export { ForwardRef as ReactComponent };